export const Mydata = {
  data() {
    // var validateRefuse = (rule,value,callback)=>{
    //    if(this.form.refuseReason == "" && this.form.photoReason.length == 0){
    //     callback(new Error("请至少填写一项"))
    //    }else{
    //     callback()
    //    }
    // };
    return {
      systemIds: [
        { id: "1", title: "Android" },
        { id: "2", title: "ios" },
        { id: "3", title: "小程序" },
      ],
      timeType: [
        { id: "1", title: "日" },
        { id: "2", title: "周" },
        { id: "3", title: "月" },
      ],
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      column: [
        {
          label: "风险确认",
          prop: "is_ack_text",
          width: "100px",
        },
        {
          label: "主体",
          prop: "subject_text",
          width: "110px",
        },
        {
          label: "项目",
          prop: "project_id_text",
          width: "120px",
        },
        {
          label: "应用",
          prop: "appid_text",
          width: "150px",
        },
        {
          label: "增长部协作者",
          prop: "increase_admin_id_text",
          width: "120px",
        },
        {
          label: "被拒时间",
          prop: "rejected_date",
          sortable: "custom",
          width: "130px",
        },
        {
          label: "发布版本",
          prop: "version",
          width: "100px",
        },
        {
          label: "审核平台",
          prop: "platform_text",
          width: "150px",
        },
        {
          label: "核心问题",
          prop: "core_issues_text",
          width: "200px",
        },
        {
          label: "风险等级",
          prop: "risk_level_text",
          width: "100px",
        },
        {
          label: "是否违规",
          prop: "is_violation_text",
          width: "100px",
        },

        {
          label: "被拒原因",
          prop: "rejected_content_case_text",
          width: "200px",
        },
        {
          label: "原因截图",
          prop: "reasonPhoto",
          width: "180px",
        },
        {
          label: "恢复时间",
          prop: "resume_date",
          sortable: "custom",
          width: "130px",
        },
        {
          label: "处理策略",
          prop: "handle_tactics",
          width: "200px",
        },
        {
          label: "操作",
          prop: "operation",
          width: "200px",
        },
      ],
      // subjectList:[],//下拉菜单主体写死选项
      // riskLevelList:[],//风险等级固定选项
      // coreProblemList:[],//核心问题写死选项
      //   riskConfirmList:[], //风险确认固定字段
      //   violationList:[], //是否违规固定字段
      rules: {
        subject: [{ required: true, message: "主体为必填项", trigger: "blur" }],
        project: [{ required: true, message: "项目为必填项", trigger: "blur" }],
        appid: [{ required: true, message: "应用为必填项", trigger: "blur" }],
        releaseVersion: [
          { required: true, message: "发布版本为必填项", trigger: "blur" },
        ],
        auditPlatform: [
          { required: true, message: "审核平台为必填项", trigger: "blur" },
        ],
        increase_admin_id: [
          { required: true, message: "增长部协作者为必填 ", trigger: "blur" },
        ],
        coreProblem: [
          { required: true, message: "核心问题为必填项", trigger: "blur" },
        ],
        riskLevel: [
          { required: true, message: "风险等级为必填项", trigger: "blur" },
        ],
        violation: [
          { required: true, message: "是否违规为必填项", trigger: "blur" },
        ],
        refuseTime: [
          { required: true, message: "被拒时间为必填项", trigger: "blur" },
        ],
        // refuseReason: [
        //   { required: true, message: "被拒原因/截图为必填项", trigger: "blur" },
        // ],
      },
      cascaderProps: {
        multiple: true,
      },
    };
  },
};
